import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export class BillingProcessService {
    constructor(private http: HttpClient) {}

    startOrResumeBillingProcess(
        trainingSessionId: number
    ): Observable<{ billingAppUrl: string }> {
        return this.http.post(
            `/api/training-sessions/${trainingSessionId}/start-or-resume-billing-process`,
            null
        ) as any;
    }

    saveTrainerTimesheet(
        trainingSessionId: number
    ): Observable<{ billingAppUrl: string }> {
        return this.http.post(
            `/api/training-sessions/${trainingSessionId}/save-trainer-timesheet`,
            null
        ) as any;
    }
}



// WEBPACK FOOTER //
// ./src/app/_services/session/billing-process.service.ts